import { action, observable, makeObservable } from 'mobx';
import { IExtension } from 'stores/extension/ExtensionStore';

export const DATTO_AV = 'Datto AV';

export type IAlert = {
    id: string;
    severity?: string;
    severityLevel?: string;
    sourceType?: string;
    name?: string;
    osVersion?: string;
    ip?: string;
    hostScanId?: string;
    completedOn?: Date;
    createdOn?: Date;
    eventTime?: Date;
    archived?: boolean;
    locationId?: string;
    locationName?: string;
    organizationId?: string;
    organizationName?: string;
    data?: IAlertData;
    response?: IExtension[];
    source: {
        name: string;
        severity?: string;
        short?: string;
        description?: string;
        data?: {
            actions?: {
                alert?: boolean;
            };
        };
        version?: {
            body: string;
        };
        recommendation?: any;
    };
    sourceId?: string;
    sourceVersionId?: string;
    signal?: unknown;
    hostname?: string;
    hostId?: string;
    type?: string;
    itemId?: string;
    flagName?: string;
    flagColor?: string;
    sha1?: string;
    size?: number;
    extensionSuccess?: null | boolean;
    sourceAuthor?: string;
    sourceName?: string;
    updatedOn?: Date;
    lastSeenOn?: Date;
    suppressionRuleVersionId?: string;
    agentId?: string;
    rmmSiteId?: string;
    rmmAccountId?: string;
    deviceId?: string;
    vsaId?: string;
    sourceText?: string;
    description?: string;
    mitreId?: string;
    mitreTactic?: string;
    md5?: string;
    sha256?: string;
    flagId?: string;
    label?: string;
};

export type IAlertData = {
    hostOs?: string;
    path?: string;
    originalPath?: string;
    reason?: string;
    grandParentProcessName?: string;
    parentProcessName?: string;
    decodedPayload?: string;
    commandLine?: string;
    items?: any[];
    protection?: string;
    eppType?: string;
    detectionName?: string;
    threatStatus?: string;
    threatCategory?: string;
    processName?: string;
    ruleType?: string;
    alerts?: string[];
    alertTime?: Date;
    detectionTime?: number;
    type?: string;
    extension?: string;
    logFilePath?: string;
    deletedFiles?: { name: string; path: string }[];
    possibleEncryptedFiles?: { name: string; path: string }[];
    possibleRansomNotes?: string[];
    processNames?: { id: string; name: string }[];
    executionStatus?: string;
    hostInfo?: IAlertDataHostInfo;
    ip?: string;
    owner?: string;
};

export type IAlertDataHostInfo = {
    agentId: string;
    architecture: string;
    cpe23Uri: string;
    domain: string;
    hostname: string;
    ip: string;
    osVersion: string;
    vsaId: string;
};

export const ALERT_SOURCE_TYPE = {
    EXTENSION: 'extension',
    COMPLIANCE: '',
    AV: 'av',
    DNS_SECURE: 'dns',
    RANSOMWARE: 'ransomware',
    RULE: 'rule',
    CORRELATION: 'correlation',
    REPUTATION: 'reputation'
};

export default class AlertStore {
    alert: IAlert = {
        id: '',
        source: { name: '' }
    };

    constructor(alert: IAlert) {
        makeObservable(this, {
            alert: observable,
            update: action
        });

        this.update(alert);
    }

    update(alert: IAlert): void {
        this.alert = {
            ...this.alert,
            ...alert
        };
    }

    public flatten(): any {
        return this._flatten(this.alert);
    }

    private _flatten(input?: any, prefix?: string, result?: any): any {
        prefix = prefix || '';
        result = result || {};
        const keys = Object.keys(input);

        keys.map((key) => {
            const item = input[key];
            if (item != null && typeof item === 'object') {
                switch (key) {
                    case 'data':
                        key = 'foundInstanceData';
                        break;
                    case 'source':
                        key = input.sourceType || 'source';
                        break;
                }

                if (key !== 'items' && key !== 'actions') {
                    this._flatten(item, key, result);
                }
            } else {
                if (key !== 'reason') {
                    result[prefix + key] = item;
                }
            }
        });

        return result;
    }
}
